import { render, staticRenderFns } from "./InstagramIntegrationForm.vue?vue&type=template&id=7d0d1616&scoped=true&"
import script from "./InstagramIntegrationForm.vue?vue&type=script&lang=ts&"
export * from "./InstagramIntegrationForm.vue?vue&type=script&lang=ts&"
import style0 from "./InstagramIntegrationForm.vue?vue&type=style&index=0&id=7d0d1616&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0d1616",
  null
  
)

export default component.exports